import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div<{ size?: string }>`
  width: ${props => props.size || '20px'};
  height: ${props => props.size || '20px'};
  display: inline-block;
  position: relative;
`;

const SpinnerRing = styled.div<{ size?: string }>`
  position: absolute;
  width: ${props => props.size || '20px'};
  height: ${props => props.size || '20px'};
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: ${spin} 0.8s linear infinite;
`;

interface SpinnerProps {
  size?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size }) => {
  return (
    <SpinnerContainer size={size}>
      <SpinnerRing size={size} />
    </SpinnerContainer>
  );
};

export default Spinner; 